import React from 'react';

function ImagePreview({ file }) {
  if (!file) {
    return null;
  }

  return (
    <div className="image-preview">
      <h3>Uploaded Image:</h3>
      <img src={URL.createObjectURL(file)} alt="Uploaded receipt" style={{ maxWidth: '100%', maxHeight: '300px' }} />
    </div>
  );
}

export default ImagePreview;